import React from 'react';

const FileOrdered = ({ file }) => {
    return (file.status === 'ParcelsCreated' || file.status === 'Processing' || file.status === 'Ordered' || file.status === 'Calculated') ? <span>{file.orderedRows} из {file.validRows}</span> : null;
};

export default FileOrdered;


// WEBPACK FOOTER //
// ./App/pages/massUpload/components/FileOrdered.jsx